import type { BudgetField, BudgetSection } from './types';

export const MAX_FIELD_VALUE = 999999;

export const RANGE_ERROR = 'Enter a number between 0 and 999,999';

export const DISCLAIMER =
  'This calculator is for educational purposes only and is not intended to offer any tax, legal, financial, or investment advice.';

export const INCOME_FIELD: BudgetField = {
  label: 'Monthly after-tax income',
  hint: 'Your total monthly income after taxes and other paycheck deductions. If you have any automatic savings deductions, like 401(k) contributions, add that amount to your income so you can include those savings in your budget below.',
};

/* Legacy WordPress copy, with duplicate "Other" labels qualified to preserve unique input ids. */
export const BUDGET_SECTIONS: readonly BudgetSection[] = [
  {
    key: 'essentials',
    heading: 'Essentials',
    hint: 'Your nonnegotiable monthly expenses, like bills, housing, and transportation.',
    fields: [
      { label: 'Housing', hint: 'Mortgage, rent, taxes, etc.' },
      { label: 'Food', hint: 'Essential groceries and food.' },
      { label: 'Utilities', hint: 'Phone, water, gas, internet, etc.' },
      { label: 'Transportation', hint: 'Car maintenance, gas, public transportation, etc.' },
      { label: 'Health', hint: 'Medications, doctor visits, etc.' },
      { label: 'Insurance', hint: 'Car, home, or health insurance, etc.' },
      { label: 'Minimum loan payments', hint: 'Your monthly minimum loan payments, including your car loan.' },
      { label: 'Other essentials', hint: 'Any other required expenses (childcare, petcare, etc.)' },
    ],
  },
  {
    key: 'wants',
    heading: 'Wants',
    hint: 'Your monthly expenses for nonnecessities, like travel, entertainment, hobbies, etc.',
    fields: [{ label: 'Entertainment' }, { label: 'Dining out' }, { label: 'Travel' }, { label: 'Other wants' }],
  },
  {
    key: 'savings',
    heading: 'Savings',
    hint: 'Your monthly contribution toward savings, like building an emergency fund or saving for retirement.',
    fields: [
      {
        label: 'Emergency fund',
        hint: 'Your monthly contribution toward an emergency fund, ideally enough to cover three to six months of living expenses.',
      },
      {
        label: 'Retirement',
        hint: 'Your monthly contribution toward your long-term retirement savings, like in a 401(k) or IRA. Enter that number here if your employer automatically deducts it from your paycheck through an employer-sponsored retirement plan.',
      },
      {
        label: 'Other savings',
        hint: 'Enter any extra savings you may be saving here. (For example, if you’re paying more than the minimum monthly payment for any loans or debts, enter those extra funds here.)',
      },
    ],
  },
];
